/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Ad_Ai_Tools_Menu_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Show AI Tools menu" |
*
* @param {Event_Ad_Ai_Tools_Menu_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_ad_ai_tools_menu_aria_label = /** @type {((inputs?: Event_Ad_Ai_Tools_Menu_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Ad_Ai_Tools_Menu_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Afficher le menu des outils IA")
	if (locale === "de") return /** @type {LocalizedString} */ ("Menü „KI-Tools anzeigen“")
	if (locale === "it") return /** @type {LocalizedString} */ ("Mostra il menu Strumenti AI")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Показать меню «Инструменты ИИ»")
	if (locale === "es") return /** @type {LocalizedString} */ ("Mostrar el menú de herramientas de IA")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("显示 AI 工具菜单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("AIツールメニューを表示")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एआई टूल्स मेनू दिखाएँ")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Mostrar menu de ferramentas de IA")
	return /** @type {LocalizedString} */ ("Show AI Tools menu")
});